import React from 'react';
import { TableRow, TableCell, TableHead } from '@mui/material';

import { keyColumn } from '../../utils/class';

export const TeacherTableHeader = ({
  showEmail = false,
  preferClassKey = false,
}: {
  showEmail?: boolean;
  preferClassKey?: boolean;
}) => {
  return (
    <TableHead>
      <TableRow>
        <TableCell>Teacher Name</TableCell>
        {showEmail && <TableCell>Email</TableCell>}
        <TableCell>Username</TableCell>
        <TableCell>{keyColumn(preferClassKey)}</TableCell>
      </TableRow>
    </TableHead>
  );
};
